import Vue from 'vue';
import Vuex from 'vuex';
// import loginCN from "./loginCN/index";
import smsCode from './smsCode';
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: { smsCode },
});

export default store;
